import { Minus, Plus } from 'lucide-react'

// 行展開の開閉トグル（発注照合テーブルの実装を切り出した共通部品）。
// 展開状態のアイコン・aria 属性はテーブルごとに異なる（対象・id・ラベル文言）ため呼び出し側から渡す
export function ExpandToggleButton({
  expanded,
  onClick,
  ariaLabel,
  ariaControls,
}: {
  expanded: boolean
  onClick: () => void
  ariaLabel: string
  ariaControls?: string
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex size-6 shrink-0 items-center justify-center rounded-md border border-border bg-card text-muted-foreground hover:border-primary/40 hover:text-primary"
      aria-expanded={expanded}
      aria-controls={ariaControls}
      aria-label={ariaLabel}
    >
      {expanded ? <Minus className="size-3.5" /> : <Plus className="size-3.5" />}
    </button>
  )
}
